import axios, { AxiosResponse } from 'axios'
import { AtendimentoReportQueryResponse } from './_models'
import { AtendimentoResumo } from '../../../atendimento_medicos/atendimentos-medico-list/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const ATENDIMENTO_RESPONSAVEL_URL = `${API_URL}/atendimentos/responsavel`

/**
 * Busca atendimento do medico responsavel
 * @param query string
 * @returns AtendimentoReportQueryResponse
 */
export const getAtendimentosByResponsavel = (
  query: string
): Promise<AtendimentoReportQueryResponse> => {
  return axios.get(`${ATENDIMENTO_RESPONSAVEL_URL}?${query}`).then((d: AxiosResponse) => d.data)
}

/**
 * Busca resumo dos atendimentos de um responsavel
 * @param query string
 * @returns AtendimentoResumo
 */
export const getResumoAtendimentosResponsavel = (query: string): Promise<AtendimentoResumo> => {
  return axios
    .get(`${ATENDIMENTO_RESPONSAVEL_URL}/resumo?${query}`)
    .then((resp: AxiosResponse) => resp.data)
}
